import {Params} from './types';
import {config} from '../../config';
export const params: Params = {
  isSp: document.documentElement.clientWidth < config.breakPoint,
  loadingComplete: false,
  isTall: document.documentElement.clientWidth < document.documentElement.clientHeight * 0.5,
  bW: document.documentElement.clientWidth,
  bH: document.documentElement.clientHeight,
};
